import { FormSectionWrapper } from "../FormSectionWrapper";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

export const AddressCheckModal = ({ formik, show, handleClose, suggestedValues, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;

    const useSuggested = () => {
        const newVals = {
            address1: suggestedValues.address1,
            address2: suggestedValues.address2 || '',
            address3: suggestedValues.address3 || '',
            city: suggestedValues.city,
            stateProvince: suggestedValues.stateProvince.length === 2 ? suggestedValues.stateProvince : '', // test env returning a state name instead of the code. will check this in prod
            country: suggestedValues.country,
            postalCode: suggestedValues.postalCode,
            residentialAddress: suggestedValues.classification === 'RESIDENTIAL' ? true : false
        }
        if (isReturnShipmentTab) {
            formik.setValues({
                ...formik.values,
                returnData: {
                    ...formik.values.returnData,
                    ...newVals
                }
            });
        } else {
            formik.setValues({
                ...formik.values,
                ...newVals
            });
        }
        handleClose();
    }

    return (
        <Modal className='modal-padding' show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>FedEx Address Checker Results</Modal.Header>
            <FormSectionWrapper title='Recipient Address Results'>
                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>You Entered</th>
                            <th>Suggested</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Address 1:</th>
                            <td>{values.address1}</td>
                            <td>{suggestedValues.address1}</td>
                        </tr>
                        <tr>
                            <th>Address 2:</th>
                            <td>{values.address2}</td>
                            <td>{suggestedValues.address2}</td>
                        </tr>
                        <tr>
                            <th>Address 3:</th>
                            <td>{values.address3}</td>
                            <td>{suggestedValues.address3}</td>
                        </tr>
                        <tr>
                            <th>City:</th>
                            <td>{values.city}</td>
                            <td>{suggestedValues.city}</td>
                        </tr>
                        <tr>
                            <th>State/Province:</th>
                            <td>{values.stateProvince}</td>
                            <td>{suggestedValues.stateProvince}</td>
                        </tr>
                        <tr>
                            <th>Country:</th>
                            <td>{values.country}</td>
                            <td>{suggestedValues.country}</td>
                        </tr>
                        <tr>
                            <th>Postal Code:</th>
                            <td>{values.postalCode}</td>
                            <td>{suggestedValues.postalCode}</td>
                        </tr>
                        <tr>
                            <th>Residential:</th>
                            <td>{values.residentialAddress ? 'YES' : 'NO'}</td>
                            <td>{(suggestedValues.classification && suggestedValues.classification === 'RESIDENTIAL') ? 'YES' : 'NO'}</td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>
                                <Button onClick={handleClose} variant='secondary'>Keep Original</Button>
                            </td>
                            <td>
                                <Button onClick={useSuggested} className='purple-btn'>Use Suggested</Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </FormSectionWrapper>
            <FormSectionWrapper title='Please Note'>
                <ul>
                    <li>Results provided by the FedEx Address Checker are believed to be reliable, but not guaranteed. Correct completion of shipping documents is the responsibility of the customer. If the delivery address is later identified as residential, you could receive a residential surcharge.</li>
                    <li>FedEx Address Checker does not support or recognize individual/personal names, but may check an address by matching company names that correspond to street addresses.</li>
                </ul>
            </FormSectionWrapper>
        </Modal>
    )
}